// Audio file import (docs/product-specs/import.md).

import { html, LitElement } from "lit";
import { ApiError, importFile } from "../lib/api";
import { navigate } from "../lib/store";

export class MmImport extends LitElement {
  private busy = false;
  private error = "";

  override createRenderRoot(): HTMLElement {
    return this;
  }

  private async submit(e: Event): Promise<void> {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const fileInput = form.elements.namedItem("file") as HTMLInputElement;
    const titleInput = form.elements.namedItem("title") as HTMLInputElement;
    const file = fileInput.files?.[0];
    if (!file) return;
    this.busy = true;
    this.error = "";
    this.requestUpdate();
    try {
      const result = await importFile(file, titleInput.value || undefined);
      navigate(`/meetings/${result.meeting.id}`);
    } catch (err) {
      this.error = err instanceof ApiError ? err.message : "import failed";
      this.busy = false;
      this.requestUpdate();
    }
  }

  override render() {
    return html`
      <section class="summary">
        <p class="eyebrow">Workspace</p>
        <h1>Import a recording</h1>
        <p class="muted">
          mp3, wav, m4a, or flac — up to 6 hours / 512 MB. Transcription and
          summary run server-side; you can close this tab once the upload
          finishes.
        </p>
      </section>
      <section>
        <form class="login-form" @submit=${this.submit}>
          <div>
            <label class="field-label" for="file">Audio file</label>
            <input id="file" name="file" type="file" accept=".mp3,.wav,.m4a,.flac" required />
          </div>
          <div>
            <label class="field-label" for="title">Title (optional)</label>
            <input id="title" name="title" type="text" placeholder="Defaults to the file name" />
          </div>
          ${this.error
            ? html`<div class="message-card message-card-error"><p>${this.error}</p></div>`
            : ""}
          <button class="primary-button" ?disabled=${this.busy}>
            ${this.busy ? "Uploading…" : "Import & transcribe"}
          </button>
        </form>
      </section>
    `;
  }
}

customElements.define("mm-import", MmImport);
